import { Controller } from "../../ts/controller";
import { Game } from "../../ts/models/game";
import { Style } from "../../ts/models/style";
import { Logger } from "../../ts/utils/logger";
import { AutoCompleteSearch } from "../../ts/web-components/auto-complete-search";
import { AutocompleteSearchModelType } from "../../ts/web-components/auto-complete-search-model-type";


export class ExamplePageController extends Controller {
    constructor() {
        super({
            logLabel: 'ExamplePageController',
        });
    }

    public initialize() {
        // Set up side nav toggle buttons
        const buttonIds = [
            'example-page-toggle-side-nav-button-1',
            'example-page-toggle-side-nav-button-2',
            'example-page-toggle-side-nav-button-3',
            'example-page-toggle-side-nav-button-4',
        ];

        /** @type {AutoCompleteSearch} */
        const searchGamesElement = this.getElementByIdOrWarn<AutoCompleteSearch<Game>>('example-search-games');
        if (searchGamesElement) {
            searchGamesElement.initialize({
                modelType: AutocompleteSearchModelType.game,
                onChange: () => {
                    console.log('Games changed!');
                },
            });
        }
        /** @type {AutoCompleteSearch} */
        const searchStylesElement = this.getElementByIdOrWarn<AutoCompleteSearch<Style>>('example-search-styles');
        if (searchStylesElement) {
            searchStylesElement.initialize({
                modelType: AutocompleteSearchModelType.style,
                prepopulatedResults: [
                    {
                        id: 1,
                        name: 'Fingerstyle',
                    },
                    {
                        id: 2,
                        name: 'Pick',
                    },
                ],
                onChange: null,
            });
        }

        Logger.info(this.logLabel, 'Initialized');
    }
}
